/**
 * Send Notifcation Modal
 *
 * This code defines a React component called NotificationSendModal that renders a modal 
 * for sending notifications to a team. It imports React, PropTypes, API, and Modal 
 * from various libraries. The component takes in three props: modalShow, modalClose, and hunt. 
 * It uses the useState hook to manage the state of the message title, body, type, 
 * whether the message has been sent, and whether the message is currently being sent. 
 * It defines a handleSubmit function that sends a notification to the team using the 
 * API utility and updates the state accordingly. The component renders a form with input 
 * fields for the message title and body, and a button to send the message. It also 
 * displays a success message when the message has been sent. 
 */

import React, { useState } from 'react'
import PropTypes from 'prop-types'
import API from '../../utils/api'
import Modal from 'react-bootstrap/Modal'

const NotificationSendModal = ({ modalShow, modalClose, hunt }) => {
  // console.log(hunt)

  const [messageTitle, setmessageTitle] = useState(``)
  const [messageBody, setmessageBody] = useState(``)
  const [messageType, setmessageType] = useState(1)
  const [messageSent, setmessageSent] = useState(false)
  const [messageError, setmessageError] = useState(``)
  const [messageLoading, setmessageLoading] = useState(false)

  const handleSubmit = event => {
    event.preventDefault()
    setmessageLoading(true)
    setmessageSent(false)
    setmessageError(``)

    const post_data = new FormData()
    post_data.append(`title`, messageTitle)
    post_data.append(`message`, messageBody)
    post_data.append(`action`, messageType)
    post_data.append(`hunt`, hunt.id)

    API.post(`/hunt/${hunt.id}/notifications/`, post_data, {
      headers: {
        Authorization: `JWT ${localStorage.getItem(`token`)}`,
      },
    })
      .then(() => {
        setmessageTitle(``)
        setmessageBody(``)
        setmessageSent(true)
        setmessageLoading(false)
      })
      .catch(() => {
        setmessageError(`Message could not be sent. Check the title and message, then try again.`)
        setmessageLoading(false)
      })
  }

  return (
    <Modal show={modalShow} onHide={modalClose} centered scrollable={true} aria-labelledby="send-notification">
      <Modal.Header className={`card-header`} closeButton>
        <Modal.Title id="progress-modal-title" className={`card-title mb-2`}>
          Send Notification
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className={`card-body bg-white text-dark`}>
        {messageSent && (
          <div className="alert alert-success" role="alert">
            Notification Sent!
          </div>
        )}
        {messageError && (
          <div className="alert alert-danger" role="alert">
            {messageError}
          </div>
        )}
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="messageTitle">Title</label>
            <input
              type="text"
              className="form-control"
              id="messageTitle"
              placeholder="Enter title"
              value={messageTitle}
              onChange={e => setmessageTitle(e.target.value)}
            />
          </div>

          <div className="form-group">
            <label htmlFor="messageBody">Message</label>
            <textarea
              className="form-control"
              id="messageBody"
              rows="3"
              value={messageBody}
              onChange={e => setmessageBody(e.target.value)}></textarea>
          </div>

          <button className="btn btn-block btn-danger" disabled={messageLoading}>
            {messageLoading ? `Sending...` : `Send`}
          </button>
        </form>
      </Modal.Body>
      <Modal.Footer>
        <button className={`btn btn-block btn-tiny mt-4`} onClick={modalClose}>
          Close
        </button>
      </Modal.Footer>
    </Modal>
  )
}

export default NotificationSendModal

NotificationSendModal.propTypes = {
  modalShow: PropTypes.bool,
  modalClose: PropTypes.func,
  hunt: PropTypes.object,
}
